module.exports = __webpack_public_path__ + "img/product-preview-79.02cdf7b.png";